<div class="card {{ size }}">
  <div class="card__icon">
    <img src="./../../../assets/icons/wallet/currency-circle-dollar-thin.svg" alt="icone simbolo valores na carteira" />
  </div>
  <div class="card__info">
    <span class="card__tittle">{{ title }}</span>
    <span class="card__data">{{ data }}</span>
    <span class="card__more-info">> Mais informações</span>
  </div>
</div>
